'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import GalleryFilters from '@/ui/segments/gallery/filters';
import Media from '@/ui/segments/gallery/media';
import { MediaModal } from '@/ui/segments/gallery/modal';
import type { GalleryContentProps } from '@/services/sanity';
type GalleryContentComponentProps = {
  galleryContent: GalleryContentProps[];
};
export default function GalleryContent(t0) {
  const $ = _c(30);
  const {
    galleryContent
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [loadedMedia, setLoadedMedia] = useState(t1);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBrainRegion, setSelectedBrainRegion] = useState(null);
  const [selectedMediaType] = useState(null);
  let t2;
  if ($[1] !== galleryContent || $[2] !== selectedBrainRegion || $[3] !== selectedMediaType) {
    let t3;
    if ($[5] !== selectedBrainRegion || $[6] !== selectedMediaType) {
      t3 = item => {
        if (selectedBrainRegion && item.brainRegion !== selectedBrainRegion) {
          return false;
        }
        if (selectedMediaType && item.mediaType !== selectedMediaType) {
          return false;
        }
        return true;
      };
      $[5] = selectedBrainRegion;
      $[6] = selectedMediaType;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = galleryContent.filter(t3);
    $[1] = galleryContent;
    $[2] = selectedBrainRegion;
    $[3] = selectedMediaType;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const filteredContent = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = mediaUrl => {
      setLoadedMedia(prev => new Set(prev).add(mediaUrl));
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleMediaLoad = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = item_0 => {
      setSelectedMedia(item_0);
      setIsModalOpen(true);
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleOpenModal = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsModalOpen(false);
      setSelectedMedia(null);
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleCloseModal = t5;
  let t6;
  if ($[11] !== galleryContent || $[12] !== selectedBrainRegion) {
    t6 = <GalleryFilters galleryContent={galleryContent} selectedBrainRegion={selectedBrainRegion} onBrainRegionChange={setSelectedBrainRegion} />;
    $[11] = galleryContent;
    $[12] = selectedBrainRegion;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== filteredContent || $[15] !== loadedMedia) {
    let t8;
    if ($[17] !== loadedMedia) {
      t8 = item_1 => {
        const mediaUrl_0 = item_1.mediaType === "video" ? item_1.video : item_1.image;
        const isLoaded = mediaUrl_0 ? loadedMedia.has(mediaUrl_0) : false;
        if (!mediaUrl_0) {
          return null;
        }
        return <Media key={`${item_1.title}-${mediaUrl_0}`} item={item_1} isLoaded={isLoaded} onLoad={() => handleMediaLoad(mediaUrl_0)} onOpenModal={() => handleOpenModal(item_1)} />;
      };
      $[17] = loadedMedia;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    t7 = filteredContent.map(t8);
    $[14] = filteredContent;
    $[15] = loadedMedia;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = <div className="grid h-full w-full grid-cols-2 gap-6 md:grid-cols-5">{t7}</div>;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t8) {
    t9 = <div className="relative flex min-h-screen w-full flex-col gap-6 px-4 py-8 md:px-6">{t6}{t8}</div>;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== isModalOpen || $[25] !== selectedMedia) {
    t10 = <MediaModal open={isModalOpen} onClose={handleCloseModal} item={selectedMedia} />;
    $[24] = isModalOpen;
    $[25] = selectedMedia;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}